import React from 'react';
import DischargePatientList from './DischargePatientList';

const DischargeAllPatients: React.FC = () => <DischargePatientList ownershipFilter="ALL" />;

export default DischargeAllPatients;
